import API from 'services/TAPS_API';
const accountsType = {
  openAccountType: '1120107',
  closeAccountType: '1120107',
  changeAccountType: '1120106',
  movementReportType: '1112520',
};
export default function getMovementReportData({ cardId, issueType, actionType }) {
  return API.request({
    method: 'GET',
    url: `/notification/${accountsType[issueType]}/cardData?cardId=${cardId}&actionType=${actionType}`,
  });
}
